import { connect } from "react-redux";
import { compose } from "recompose";
import { getDeviceName } from "src/modules/auth/duck/selectors";
import { withMessenger } from "src/modules/messenger/Provider";
import { withApp } from "src/components/App/Context";

import { getResponse, getRequest } from "../../duck/selectors";
import { onReceivedResponse, handlePairingCancelation } from "../../duck/epics";
import WaitingForResponse from "./Waiting";

function mapStateToProps(state) {
  return {
    response: getResponse(state),
    deviceName: getDeviceName(state),
    request: getRequest(state)
  };
}

const enhance = compose(
  withApp,
  withMessenger,
  connect(
    mapStateToProps,
    (dispatch, { flow, closeWizard, messenger, app }) => ({
      onReceivedResponse: () => {
        dispatch(
          onReceivedResponse({
            flow,
            messenger,
            app,
            didLogIn: flow.state.didLogIn,
            didSignUp: flow.state.didSignUp
          })
        );
      },
      onBack: () => dispatch(handlePairingCancelation({ flow })),
      onClose: () => dispatch(handlePairingCancelation({ closeWizard }))
    })
  )
);

export default enhance(WaitingForResponse);
